import { useMemo } from 'react';
import { isEmpty } from 'lodash';
import useRecordContext from '../../../../utilities/RecordContextProviderUtilities';
import {
    ACCESSPOINT,
    FIREWALL,
    GENERIC,
    PACKET_PROCESSOR,
    ROUTER,
    SERVER,
    SWITCH,
    WIRELESSCONTROLLER,
} from '../InfrastructureConstants';

/**
 * Hook providing device type context with derived boolean flags.
 * Mirrors useVirtualInfraContext() pattern for monitored device types.
 * @returns {Object} Device context with type flags and state
 */
export const useDeviceInfraContext = () => {
    const { type: deviceType, id } = useRecordContext();

    return useMemo(() => {
        const hasId = !isEmpty(id);
        const isCreateAction = !hasId;

        return {
            deviceType,
            id,
            hasId,
            isCreateAction,
            isServer: deviceType === SERVER,
            isAccessPoint: deviceType === ACCESSPOINT,
            isWirelessController: deviceType === WIRELESSCONTROLLER,
            isRouter: deviceType === ROUTER,
            isSwitch: deviceType === SWITCH,
            isFirewall: deviceType === FIREWALL,
            isGeneric: deviceType === GENERIC,
            isPacketProcessor: deviceType === PACKET_PROCESSOR,
        };
    }, [id, deviceType]);
};
